// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NI21","content":"styles_content__2fnvj"};